import { useCallback } from 'react';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';

export const useLogCompleteDownloadCouponAll = () => {
  const logGoodsAnalyticsEvent = useLogGoodsAnalyticsEvent();

  return useCallback(() => {
    logGoodsAnalyticsEvent({
      name: 'COMPLETE_DOWNLOAD_COUPON_ALL',
    });
  }, [logGoodsAnalyticsEvent]);
};
